var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dot",style:({'background-color': _vm.getDotColor})})
}
var staticRenderFns = []

export { render, staticRenderFns }